import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import 'rxjs';

import { AlertService } from '../../../providers/alert-service';
import { RelatoriosContabeisService } from '../../../providers/relatorios-contabeis-service';
import { OrcamentoService } from '../../../providers/orcamento-service';


/*
  Generated class for the ModalVincularArquivo page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-vincular-arquivo',
  templateUrl: 'modal-vincular-arquivo.html',
  providers: [
    RelatoriosContabeisService,
    OrcamentoService
  ]
})
export class ModalVincularArquivoPage {

  relatorio: any = null;
  listaArquivos: any = [];
  titulo: any;
  isJurisdicionado: any;
  servico: any;
  tiposAceitos: any;
  loading: any = false;

  constructor(private alertService: AlertService, private viewCtrl: ViewController, public navParams: NavParams, public relatoriosContabeisService: RelatoriosContabeisService, public OrcamentoService: OrcamentoService) {
    this.titulo = this.navParams.get('titulo');
    this.relatorio = this.navParams.get('objeto');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.servico = this.navParams.get('servico');
    this.tiposAceitos = this.navParams.get('tiposaceitos');
    this.carregarModal();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivos();
  }

  listarArquivos() {
    this.servico.listarArquivos(this.relatorio).subscribe(data => {
      this.listaArquivos = data;
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Não foi possível listar os arquivos.");
    });
  }

  baixarArquivo(arquivo) {
    this.loading = true;
    this.servico.downloadfile(arquivo);
    this.loading = false;
  }

  fileChange(event) {
    if (this.listaArquivos.length < 2) {
      this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Você tem certeza que deseja salvar o arquivo?",
        retornoModal => {
          if (retornoModal) {

            let fileList: FileList = event.target.files;
            if (fileList.length > 0) {
              let file: File = fileList[0];

              if (file.size <= 10485760) {
                this.servico.salvarArquivo(event, this.relatorio).subscribe(data => {
                  this.alertService.mostraAlerta("Arquivo salvo com sucesso!", "");
                  this.listarArquivos();
                }, error => {
                  this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar o arquivo" + error);
                  console.log("erro: " + error);
                });
              } else {
                this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
              }
            }
          }
        }
      );
    } else {
      this.alertService.mostraAlerta("", "Não é possível adicionar mais de dois aquivos.");
    }
  }

  deletarArquivo(arquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + arquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.servico.deletarArquivo(arquivo).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.listaArquivos = data;
            this.listarArquivos();
          }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-vincular-arquivo/modal-vincular-arquivo.ts